import { Route, Routes } from "react-router-dom";
import { Categories, CategoriesFeild, Feilds, FeildValue } from "../modules/taxonomy/index.js";
import { Gallery, Sliders } from "../modules/media-content/index.js";
import { Users, User } from "../modules/identity-access/index.js";
import { Booth } from "../modules/exhibitors/index.js";



import { WishLists, LastVisits } from "../modules/engagement/index.js";

import { Advertisment, AdvertismentData, CreateAds, ReviewAds, Promotions } from "../modules/listings/index.js";

import { Conversation } from "../modules/messaging/index.js";
import { ReportTransactions, PaymentGatewaySettings, PaymentSandbox } from "../modules/billing/index.js";



import { Country, States, City, Regions } from "../modules/geography/index.js";




import { Configs, CompanyInfo } from "../modules/settings/index.js";



/** Preserves every legacy URL and route element at the app composition boundary. */
export const panelRoutes = [
  { path: "/", element: (<Categories to="/locategorygin" replace />) },
  { path: "/category", element: (<Categories />) },
  { path: "/booth", element: (<Booth />) },
  { path: "/users", element: (<Users />) },
  { path: "/users/:id", element: (<User />) },
  { path: "/category/:id", element: (<CategoriesFeild />) },
  { path: "/field", element: (<Feilds />) },
  { path: "/field/:id", element: (<FeildValue />) },
  { path: "/wishList", element: (<WishLists />) },
  { path: "/lastVisit", element: (<LastVisits />) },
  { path: "/advertisment", element: (<Advertisment />) },
  { path: "/promotions", element: (<Promotions />) },
  { path: "/advertisment/create", element: (<CreateAds />) },
  { path: "/advertismentData", element: (<AdvertismentData />) },
  { path: "/chat", element: (<Conversation />) },
  { path: "/transaction", element: (<ReportTransactions />) },
  { path: "/payment-gateway", element: (<PaymentGatewaySettings />) },
  { path: "/payment-sandbox", element: (<PaymentSandbox />) },
  { path: "/gallery", element: (<Gallery />) },
  { path: "/slider", element: (<Sliders />) },
  { path: "/country", element: (<Country />) },
  { path: "/state", element: (<States />) },
  { path: "/city", element: (<City />) },
  { path: "/region", element: (<Regions />) },
  { path: "/chat/:id", element: (<Conversation />) },
  { path: "/configs", element: (<Configs />) },
  { path: "/companyInfo", element: (<CompanyInfo />) },
  { path: "/advertisment/:id", element: (<ReviewAds />) },
];

export default function PanelRoutes() {
  return <Routes>{panelRoutes.map(({ path, element }) => <Route key={path} path={path} element={element} />)}</Routes>;
}
